export default __webpack_public_path__ + "static/media/14.01555dc3.jpg";